import { type AllergenProperty } from '@sg/graphql-schema';

import { type AllergenTypes } from '../../machines';

/**
 * Returns a formatted string of matched allergens between the user's selected
 * allergens and a product's allergen properties.
 */
export const getProductDietaryRestrictionsNames = (
  userRestrictions: AllergenTypes,
  allergenProperties: readonly AllergenProperty[] | undefined,
) => {
  const activeRestrictions = (allergenProperties ?? []).filter(
    (property) => userRestrictions[property.name],
  );

  const restrictionNames = activeRestrictions.map((restriction) =>
    restriction.name.toLowerCase().replaceAll('_', ' '),
  );

  return restrictionNames.join(', ');
};
